<template>
  <div class="app-container">
    <el-row :gutter="20">
      <!-- 模板列表 -->
      <el-col :span="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-row :gutter="20">
              <el-col :span="18">
                <!-- 使用自定义工具栏按钮组件 -->
                <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleAdd="handleAdd" @handleExport="handleExport" @handleSearch="handleSearch" />
              </el-col>
              <el-col :span="6">
                <el-input v-model="searchText" placeholder="请输入模板名称搜索" clearable size="small" prefix-icon="el-icon-search" @keyup.enter.native="handleSearch" />
              </el-col>
            </el-row>
          </div>

          <el-table :data="templateList" border style="width: 100%" @row-click="handleRowClick" :row-class-name="tableRowClassName" v-loading="loading">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <!-- 检测小区名称 -->
            <el-table-column prop="configReportName" label="检测报告" min-width="60" show-overflow-tooltip></el-table-column>
            <!-- 模版类别 -->
            <el-table-column prop="templateType" label="模版类别" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.templateType === '1' || scope.row.templateType === 1 ? '原始记录模板' : '报告' }}
              </template>
            </el-table-column>
            <!-- 模版名称 -->
            <el-table-column prop="templateName" label="模版名称" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- 模版文件（显示UUID名或文件名） -->
            <el-table-column prop="templateUUIDName" label="模版文件" min-width="180" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button type="text" @click.stop="handleDownload(scope.row)">{{ scope.row.fileName || scope.row.templateUUIDName }}</el-button>
              </template>
            </el-table-column>
            <!-- 是否启用 -->
            <el-table-column prop="enableState" label="是否启用" min-width="100" align="center">
              <template slot-scope="scope">
                <!-- 根据 enableState 值展示启用/停用标签 -->
                <el-tag :type="(scope.row.enableState == '1' || scope.row.enableState === true || scope.row.enableState === '启用') ? 'success' : 'info'">
                  {{ (scope.row.enableState == '1' || scope.row.enableState === true || scope.row.enableState === '启用') ? '启用' : '停用' }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 是否默认 -->
            <el-table-column prop="isDefault" label="是否默认" min-width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="(scope.row.isDefault == '1' || scope.row.isDefault === true || scope.row.isDefault === '默认') ? 'success' : 'info'">
                  {{ (scope.row.isDefault == '1' || scope.row.isDefault === true || scope.row.isDefault === '默认') ? '默认' : '不默认' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center" fixed="right">
              <template slot-scope="scope">
                <!-- 使用自定义行按钮组件 -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEdit="handleEdit(scope.row)" @handleDelete="handleDelete(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <el-pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增/修改模板对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form ref="templateForm" :model="formData" :rules="formRules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <!-- 模版类别 -->
            <el-form-item label="模版类别" prop="templateType">
              <el-select v-model="formData.templateType" placeholder="请选择模版类别" style="width: 100%;">
                <el-option label="报告模板" value="0" />
                <el-option label="原始记录模板" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 模版名称 -->
            <el-form-item label="模版名称" prop="templateName">
              <el-input v-model="formData.templateName" placeholder="请输入模版名称" />
            </el-form-item>
          </el-col>

          <!-- 检测报告名称 -->
          <!-- <el-col :span="24">
            <el-form-item label="检测报告名称" prop="configReportPid">
              <el-select v-model="formData.configReportPid" placeholder="请选择检测报告名称" style="width: 100%;">
                <el-option v-for="item in configReportOptions" :key="item.configReportPid" :label="item.configReportName" :value="item.configReportPid" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <!-- 模版文件（上传后后端返回UUID文件名，存入 templateUUIDName） -->
            <el-form-item label="模版文件" prop="templateUUIDName">
              <el-upload class="upload-demo" drag :action="uploadAction" :headers="uploadHeaders" :on-success="handleFileSuccess" :on-error="handleFileError" :before-upload="beforeFileUpload"
                         :file-list="fileList" :limit="1" :auto-upload="true" :http-request="uploadFile" ref="fileUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传doc/docx/xls/xlsx/pdf文件，且不超过10MB</div>
              </el-upload>
              <!-- 显示上传进度 -->
              <div v-if="tipText" style="margin-top: 10px;">
                <el-progress :percentage="uploadProgress" :show-text="false"></el-progress>
                <span style="font-size: 12px; color: #666;">{{ tipText }}</span>
              </div>
              <div v-if="formData.fileName" class="file-info">
                <!-- 展示已选择/上传后的模版UUID文件名 -->
                <el-tag type="success">{{ formData.fileName }}</el-tag>
                <el-button type="text" @click="previewFileInDialog">预览</el-button>
                <el-button type="text" @click="clearFile">清除文件</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 是否启用：使用开关，1=启用，0=停用 -->
            <el-form-item label="是否启用" prop="enableState">
              <el-switch v-model="formData.enableState" :active-value="'1'" :inactive-value="'0'"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 是否启用：使用开关，1=启用，0=停用 -->
            <el-form-item label="是否默认" prop="isDefault">
              <el-switch v-model="formData.isDefault" :active-value="'1'" :inactive-value="'0'"></el-switch>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- PDF预览对话框 -->
    <el-dialog title="文件预览" :visible.sync="isPdfViewVisible" width="80%" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="viewFileName"></PdfImgViewer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isPdfViewVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { appjs } from '@/utiljs/apputil'
import PdfImgViewer from "@/components/pdfview/PdfImgViewer.vue";
// 导入自定义按钮组件
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import PermissionMethodRow from '@/components/button/PermissionMethodRow.vue'
import { queryTemplate, saveTemplate, queryAllConfigReport, deleteTemplate, exportTemplate, updateTemplate, downloadTemplate } from '@/api/contract/contract'
export default {
  name: 'TemplateManage',
  components: {
    PermissionMethodToolbar,
    PermissionMethodRow,
    PdfImgViewer
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 遮罩层
      loading: true,
      // 当前选中行
      currentRow: null,
      // 搜索文本
      searchText: '',
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      // 总条数
      total: 0,
      // 模板列表
      templateList: [],
      // 检测报告下拉选项
      configReportOptions: [],
      // 对话框标题
      dialogTitle: '',
      // 是否显示对话框
      dialogVisible: false,
      // 文件上传相关
      uploadAction: '#',
      uploadHeaders: { Authorization: "Bearer " + getToken() },
      fileList: [],
      // 表单数据（调整为指定的5个字段）
      formData: {
        id: undefined,
        templateType: '',        // 模版类别
        templateName: '',        // 模版名称
        templateUUIDName: '',    // 模版文件（UUID文件名）
        enableState: '1',          // 是否启用：1启用/0停用
        isDefault: '0',            // 是否默认：1默认/0不默认
        configReportPid: ''      // 检测报告PID（实际传值）
      },
      // 表单校验（按需必填）
      formRules: {
        templateType: [{ required: true, message: '模版类别不能为空', trigger: 'blur' }],
        templateName: [{ required: true, message: '模版名称不能为空', trigger: 'blur' }],
        configReportPid: [{ required: true, message: '检测报告不能为空', trigger: 'blur' }]
      },
      // 模拟数据库数据
      mockDatabase: [

      ],
      // 文件上传进度相关
      uploadProgress: 0,
      tipText: '',
      isPdfViewVisible: false,
      viewFileName: '',
    }
  },
  created () {
    this.getList()
    this.getConfigReportOptions()
  },
  methods: {
    /** 查询模板列表 */
    getList () {
      this.loading = true
      queryTemplate(this.queryParams).then(res => {
        this.templateList = res.dataList
        this.queryParams.pageNum = res.curPage
        this.queryParams.pageSize = res.pageSize
        this.total = res.totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    /** 查询检测报告下拉选项 */
    getConfigReportOptions () {
      queryAllConfigReport().then(res => {
        console.log(res)
        this.configReportOptions = res
      })
    },
    /** 搜索按钮操作 */
    handleSearch () {
      this.getList()
    },
    /** 表格行点击事件 */
    handleRowClick (row) {
      this.currentRow = row
    },
    /** 表格行样式 */
    tableRowClassName ({ row }) {
      if (this.currentRow && this.currentRow.id === row.id) {
        return 'current-row'
      }
      return ''
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.dialogTitle = '添加模板'
      this.dialogVisible = true
      // 重置为5个字段
      this.formData = {
        id: undefined,
        templateType: '',
        templateName: '',
        templateUUIDName: '',
        enableState: '1',
        isDefault: '0',
        configReportPid: ''
      }
      this.fileList = []
    },
    /** 修改按钮操作 */
    handleEdit (row) {
      this.dialogTitle = '修改模版'
      const template = row || this.currentRow
      if (!template) {
        this.$message.warning('请先选择要修改的模版')
        return
      }
      this.formData = { ...template }
      console.log(this.formData)
      // 确保正确设置ID字段（后端字段名为templatePid）
      this.formData.id = template.templatePid
      // 如果有文件，设置文件列表
      if (template.templateUUIDName) {
        this.fileList = [{
          name: template.fileName || template.templateUUIDName,
          fileUUID: template.templateUUIDName,
          url: template.templateUUIDName
        }]
        // 确保设置 formData.fileName 以便显示预览和清除按钮
        this.formData.fileName = template.fileName || template.templateUUIDName;
      } else {
        this.fileList = []
        this.formData.fileName = ''
      }
      // 清空上传状态
      this.tipText = ''
      this.uploadProgress = 0
      this.dialogVisible = true
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      // 如果是从行按钮调用的，row是行数据；如果是从工具栏调用的，使用currentRow
      const template = row || this.currentRow
      if (!template) {
        this.$message.warning('请先选择要删除的模板')
        return
      }
      this.$confirm(`是否确认删除模板 "${template.templateName}"?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTemplate(row.templatePid).then(res => {
          if (res.retCode == 'ok') {
            this.$message.success('删除成功')
            this.getList()
            this.currentRow = null
          } else {
            this.$message.error(res.retMsg || '删除失败')
          }
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    /** 导出按钮操作 */
    /** 下载模板文件 */
    handleDownload (row) {
      downloadTemplate({ templatePid: row.templatePid }).then(response => {
        const blob = new Blob([response], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = row.fileName || row.templateUUIDName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$message.success('下载成功');
      }).catch(error => {
        console.error('下载失败:', error);
        this.$message.error('下载失败：' + (error.message || '未知错误'));
      });
    },

    /** 导出按钮操作 */
    handleExport () {
      this.$message.success('正在导出标准数据...')

      // 调用导出接口
      exportTemplate(this.queryParams).then(response => {
        // 创建下载链接
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = '模板管理.xlsx'; // 文件名

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },
    /** 对话框关闭事件 */
    handleDialogClose () {
      this.$refs.templateForm.resetFields()
      this.fileList = []
    },
    /** 提交按钮 */
    submitForm () {
      this.$refs.templateForm.validate(valid => {
        if (valid) {
          if (this.formData.tenantPid) {
            updateTemplate(this.formData).then(res => {
              if (res.retCode == 'ok') {
                this.$message.success('修改成功')
                this.formData = {
                  id: undefined,
                  templateType: '',
                  templateName: '',
                  templateUUIDName: '',
                  enableState: '1',
                  isDefault: '0',
                  configReportPid: ''
                }
                // 清空文件列表
                this.fileList = []
                // 如果有上传进度和提示，也一并清空
                this.tipText = ''
                this.uploadProgress = 0
                this.dialogVisible = false
                this.getList()
              } else {
                this.$message.error(res.retMsg || '修改失败')
              }
            })
          } else {
            saveTemplate(this.formData).then(res => {
              if (res.retCode == 'ok') {
                this.$message.success('新增成功')
                // 新增成功后，重置表单数据，置空表单
                this.formData = {
                  id: undefined,
                  templateType: '',
                  templateName: '',
                  templateUUIDName: '',
                  enableState: '1',
                  isDefault: '0',
                  configReportPid: ''
                }
                // 清空文件列表
                this.fileList = []
                // 如果有上传进度和提示，也一并清空
                this.tipText = ''
                this.uploadProgress = 0
                // 重置表单校验状态
                if (this.$refs.templateForm) {
                  this.$refs.templateForm.resetFields()
                }
                this.dialogVisible = false
                this.getList()
              } else {
                this.$message.error(res.retMsg || '新增失败')
              }
            }).catch(err => {
              this.$message.error(err.retMsg || '新增失败')
            })
          }
        }
      })
    },
    //上传文件
    //上传文件
    uploadFile (fileData) {
      var _self = this;
      var formdata = new FormData();
      formdata.append("file", fileData.file);
      var name = fileData.file.name;
      var type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);

      // 重置上传进度
      this.uploadProgress = 0;
      this.tipText = "准备上传...";

      // 确保使用正确的API路径
      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        // 计算上传进度
        _self.uploadProgress = Math.round((event.loaded / event.total) * 100);
        _self.tipText = "文件上传中:" + _self.uploadProgress + "%";
      }).then((data) => {
        // console.log(data)
        // 根据实际接口返回格式处理
        if (data.retCode && data.retCode === "ok") {
          // console.log(data)
          // fileData.onSuccess();
          // 设置文件信息到formData
          _self.formData.fileName = name;
          _self.formData.fileUrl = data.retMsg;
          _self.formData.templateUUIDName = data.retMsg; // 使用正确的字段名
          // 同时更新文件列表中的对象，确保包含所有必要字段
          _self.fileList = [{
            name: name,
            fileUUID: data.retMsg,
            url: data.retMsg
          }];
          _self.tipText = '上传完成！';
          _self.uploadProgress = 100;
          appjs.showSuccessMsg("上传成功");
        } else {
          fileData.onError();
          appjs.showErrorMsg(data.retMsg || '文件上传失败');
          _self.tipText = '';
          _self.uploadProgress = 0;
        }
      }).catch((error) => {
        console.log(error)
        fileData.onError();
        appjs.showErrorMsg("异常：" + error);
        _self.tipText = '';
        _self.uploadProgress = 0;
      })
    },
    /** 文件上传成功处理 */
    handleFileSuccess (response, file, fileList) {
      // 兼容后端返回字段：优先 templateUUIDName，兜底使用 fileName
      console.log(response.retCode == 'ok', response)

      if (response.retCode == 'ok') {
        // 将后端返回的UUID文件名写入表单
        this.formData.templateUUIDName = response.templateUUIDName || response.fileName || ''
        this.$message.success('文件上传成功')
      } else {
        this.$message.error(response.msg || '文件上传失败')
      }
    },
    /** 文件上传失败处理 */
    handleFileError (error, file, fileList) {
      // this.$message.error('文件上传失败')
    },
    /** 文件上传前处理 */
    beforeFileUpload (file) {
      const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/pdf']
      const maxSize = 10 * 1024 * 1024 // 10MB

      if (!allowedTypes.includes(file.type)) {
        this.$message.error('只能上传doc/docx/xls/xlsx/pdf文件')
        return false
      }

      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }

      return true
    },
    // 在修改对话框中预览文件
    previewFileInDialog () {
      console.log(this.formData.templateUUIDName);

      if (this.formData.templateUUIDName) {
        this.viewFileName = this.formData.templateUUIDName;
        this.isPdfViewVisible = true;
        this.$nextTick(() => {
          if (this.$refs.pdfImgViewer) {
            this.$refs.pdfImgViewer.init();
          }
        });
      }
    },
    /** 清除已选择的文件 */
    clearFile () {
      this.formData.templateUUIDName = ''
      this.fileList = []
      this.$refs.fileUpload.clearFiles()
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  margin-bottom: 20px;
}

.el-table ::v-deep .current-row {
  background-color: #ecf5ff;
}

.upload-demo {
  width: 100%;
}

.file-info {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.file-info .el-tag {
  margin-right: 10px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>